import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import TableC from '../../../basicElement/TableC';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

class Detail extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { record: { competingCompanyManifestationId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.competeCompany.queryUpdateDetail,
            data: { competingCompanyManifestationId },
            dataType: 'json',
            doneResult: res => {
                const { datas } = res;
                const { companyUpdateTimeList } = datas || {};
                this.setState({
                    data: companyUpdateTimeList || [],
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => ([
        {
            title: '更新时间',
            dataIndex: 'updateTime',
            key: 'updateTime',
            width: 80,
        }, {
            title: '更新人',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 110,
            render: (text, record) => {
                const { employeeCode } = record;
                return `${text}${employeeCode ? `(${employeeCode})` : ''}`;
            }
        }, {
            title: '更新字段',
            dataIndex: 'updateFilled',
            key: 'updateFilled',
            width: 120,
        }, {
            title: '更新前',
            dataIndex: 'updateBeforeData',
            key: 'updateBeforeData',
            width: 120,
        },  {
            title: '更新后',
            dataIndex: 'updateAfterData',
            key: 'updateAfterData',
            width: 170,
        }
    ])

    render() {
        const { visible, loading, record, data } = this.state;
        const { companyName, hospitalName, departmentLocalName } = record;
        return (
            <Modal
                title="更新明细"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="660px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        竞争公司名称：{companyName}
                        <span className="ant-divider" />
                        医院名称：{hospitalName}
                        <span className="ant-divider" />
                        科室：{departmentLocalName}
                    </div>
                    <TableC
                        loading={loading}
                        scrollY={270}
                        columns={this.getColumns()}
                        data={data}
                        className="updateDetail"
                        rowKey="jdeApplyApprovalHistoryId"
                    />
                </div>
            </Modal>
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/components/competeCompany/Performance/components/Detail.js